import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import swal from "sweetalert";
import config from "../../config";
import formatError from "../../services/FormatError";
import {
  loadingToggleAction,
  loginConfirmedAction,
} from "../../store/actions/AuthActions";
import {
  loginProfile,
  runLogoutTimer,
  saveTokenInStorage,
} from "../../services/AuthService";
import { useTranslation } from "react-i18next";


function ProfileSuggestion() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const navigate = useNavigate();

  const role = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.user;

  const onCreateProfile = (route) => {
    navigate(route, { state: true, replace: true });
  };

  const onLoginProfile = (url, text) => {
    loginProfile(url)
      .then((res) => {
        saveTokenInStorage(res.data);
        runLogoutTimer(dispatch, 60 * 60 * 1000, navigate);
        dispatch(loginConfirmedAction(res.data));
        dispatch(loadingToggleAction(true));
        dispatch(loadingToggleAction(false));
        swal("Success", `${t("hloggedas")} ${text} ${t("hsuccessful")}`, "success");
        navigate("/business", { replace: true });
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const onSkip = () => {
    navigate("/business", { replace: true });
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: "9999",
      }}
    >
      <div className="d-flex flex-column justify-content-center align-items-center h-100 w-100">
        <div class="content">
          <h1>{t("hwelcome")}</h1>
          <p className="mb-5">
            {t("hchooseProfile")}{" "}
            {role?.buyerprofile?.id === 0 &&
            role?.sellerprofile?.id === 0 &&
            role?.professional?.id === 0
              ? t("globalCreateButton")
              : t("hlogin")}
            :
          </p>

          {role?.buyerprofile?.id === 0 &&
          role?.sellerprofile?.id === 0 &&
          role?.professional?.id === 0 ? (
            <div className="d-flex justify-content-around align-items-center">
              <div class="suggestion-card">
                <i class="fa fa-user" aria-hidden="true"></i>
                <h2>{t("sidebarItemBuyerProfile")}</h2>
                <button type="button" onClick={() => onCreateProfile("/buyer")}>
                  {t("globalCreateButton")}
                </button>
              </div>
              <div class="suggestion-card">
                <i class="fa fa-user" aria-hidden="true"></i>
                <h2>{t("sidebarItemSellerProfile")}</h2>
                <button
                  type="button"
                  onClick={() => onCreateProfile("/seller")}
                >
                  {t("globalCreateButton")}
                </button>
              </div>
              {/* <div class="suggestion-card">
                                <i class="fa fa-user" aria-hidden="true"></i>
                                <h2>Professional Profile</h2>
                                <button type="button" onClick={() => onCreateProfile('/professional')}>Create</button>
                            </div> */}
            </div>
          ) : (
            <div className="d-flex justify-content-around align-items-center">
              {role?.buyerprofile?.id !== 0 && (
                <div class="suggestion-card">
                  <i class="fa fa-user" aria-hidden="true"></i>
                  <h2>{t("sidebarItemBuyerProfile")}</h2>
                  <button
                    type="button"
                    onClick={() =>
                      onLoginProfile(config.routes.buyerProfileLogin, "buyer")
                    }
                  >
                    {t("hlogin")}
                  </button>
                </div>
              )}

              {role?.sellerprofile?.id !== 0 && (
                <div class="suggestion-card">
                  <i class="fa fa-user" aria-hidden="true"></i>
                  <h2>{t("sidebarItemSellerProfile")}</h2>
                  <button
                    type="button"
                    onClick={() =>
                      onLoginProfile(config.routes.sellerProfileLogin, "seller")
                    }
                  >
                    {t("hlogin")}
                  </button>
                </div>
              )}

              {/* {role?.professional?.id !== 0 && (
                                <div class="suggestion-card">
                                    <i class="fa fa-user" aria-hidden="true"></i>
                                    <h2>Professional Profile</h2>
                                    <button type="button" onClick={() => onLoginProfile(config.routes.professionalProfileLogin, 'professional')}>Login</button>
                                </div>
                            )} */}
            </div>
          )}
        </div>

        <div className="d-flex flex-row justify-content-center align-items-center text-end w-100">
          <button
            type="button"
            className="btn btn-warning-outline suggestion-btn"
            onClick={onSkip}
          >
           {t("hskip")} {">>>"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProfileSuggestion;
